import {RangeModel} from '../shared/range.model';
import {Enums} from '../../extensions/enums';
import {QuestionExtendedModel} from '../question-extended.model';

export class NumberPatternSingleFillModel extends QuestionExtendedModel {

  model: {
    firstRange: RangeModel,
    patternOpType: string,
    patternValue: RangeModel,
    missingValueIndex: number,
    missingValueIndexRange: RangeModel,
    numPatternValues: number,
    possibleAnswers: RangeModel,
    numAnswers: number
  } = {
    firstRange: new RangeModel(),
    patternOpType: Enums.OperationTypes.addition,
    patternValue: new RangeModel(),
    missingValueIndex: 0,
    missingValueIndexRange: new RangeModel(),
    numPatternValues: 3,
    possibleAnswers: new RangeModel(),
    numAnswers: 4
  };

  static generateModel(json: any): NumberPatternSingleFillModel {

    const q  = new NumberPatternSingleFillModel();

    const model = json.model;
    if (model) {

      if (model.firstRange) {
        q.model.firstRange = RangeModel.generateModel(model.firstRange);
      }

      if (model.patternValue) {
        q.model.patternValue = RangeModel.generateModel(model.patternValue);
      }

      if (model.missingValueIndexRange) {
        q.model.missingValueIndexRange = RangeModel.generateModel(model.missingValueIndexRange);
      } else {
        q.model.missingValueIndexRange = new RangeModel(model.missingValueIndexRange, model.missingValueIndexRange);
      }

      if (model.possibleAnswers) {
        q.model.possibleAnswers = RangeModel.generateModel(model.possibleAnswers);
      }

      q.model.patternOpType = model.patternOpType;
      q.model.missingValueIndex = model.missingValueIndex;
      q.model.numPatternValues = model.numPatternValues;
      q.model.numAnswers = model.numAnswers;

    }

    return q;

  }

}
